import createExpense from "./Container"

export default createExpense
